// extracted by mini-css-extract-plugin
module.exports = {"input":"ForgotPasswordForm_input__1wOX2","textInfo":"ForgotPasswordForm_textInfo__3HzrR"};